import { render, staticRenderFns } from "./configBibleList.vue?vue&type=template&id=75782a80&"
import script from "./configBibleList.vue?vue&type=script&lang=js&"
export * from "./configBibleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports